/* eslint-disable class-methods-use-this */
import { IDataRepo, IModalContentService } from 'common/contracts';
import { IMenu } from 'components/Menus/Menu';
import { ControlRoomRepo, DataHallRepo, ElectricalSwitchRoomRepo, EmergencyPowerSupplyRoomRepo } from 'data/dataCenter';
import Product from 'pages/Room/Products/Product';
import Room from 'pages/Room/Room';
import store from 'store/store';

export default class DataCenterModalContentService implements IModalContentService {
  getMenu(): IMenu[] | IDataRepo[] {
    const { modalReducer } = store.getState();

    switch (true) {
      case modalReducer.primaryModalContentOf.startsWith('dataCenter/dataHall'):
        return DataHallRepo;
      case modalReducer.primaryModalContentOf.startsWith('dataCenter/electricalSwitchRoom'):
        return ElectricalSwitchRoomRepo;
      case modalReducer.primaryModalContentOf.startsWith('dataCenter/controlRoom'):
        return ControlRoomRepo;
      case modalReducer.primaryModalContentOf.startsWith('dataCenter/emergencyPowerSupplyRoom'):
        return EmergencyPowerSupplyRoomRepo;

      default:
        return DataHallRepo;
    }

    return [];
  }

  getLeftContent() {
    const { modalReducer } = store.getState();

    return <Room mRoute={modalReducer.primaryModalContentOf} />;
    // switch (true) {
    //   case modalReducer.primaryModalContentOf.startsWith('dataCenter/dataHall'):
    //     return <DataHallModal />;
    //   case modalReducer.primaryModalContentOf.startsWith('dataCenter/electricalSwitchRoom'):
    //     return <ElectricalSwitchRoomModal />;
    //   case modalReducer.primaryModalContentOf.startsWith('dataCenter/controlRoom'):
    //     return <ControlRoomModal />;
    //   case modalReducer.primaryModalContentOf.startsWith('dataCenter/emergencyPowerSupplyRoom'):
    //     return <EmergencyPowerSupplyRoomModal />;
    //   default:
    //     return <DataHallModal />;
    // }
  }

  getSecondaryModalContent() {
    const { modalReducer } = store.getState();

    return <Product id={modalReducer.secondaryModalContentOf} />;
  }
}
